import changeCase from 'change-case-object'
import store from 'src/store'

export default class SubResourceHelper {
  constructor (original, subResource) {
    this.original = original

    this.meta = subResource.requestData
    this.nameString = subResource.name
    this.idString = subResource.name + 'Id'
    this.actions = subResource.actions
    this.subResource = subResource
  }

  createRequest (data) {
    return Object.assign({}, this.meta, data)
  }

  create (data) {
    return store.dispatch(this.actions.create, this.createRequest({ data: changeCase.snakeCase(data) }))
  }

  update (data) {
    const request = {}
    request[this.idString] = data.id
    request[this.nameString] = changeCase.snakeCase(data)

    return store.dispatch(this.actions.update, this.createRequest(request))
  }

  remove (data) {
    const request = {}
    request[this.idString] = data.id

    return store.dispatch(this.actions.remove, this.createRequest(request))
  }

  diff (modified) {
    modified = modified.filter(obj => !this.subResource.isEmpty(obj))

    const findById = (id, items) => items.find(item => item.id === id)
    const equals = (a, b) => JSON.stringify(a) === JSON.stringify(b)

    return Promise.all([
      ...modified.map(resource => {
        // create new resource
        if (this.subResource.isNew(resource) && !this.subResource.isEmpty(resource)) {
          return this.create(resource)
        }

        // update changed resources
        if (!equals(resource, findById(resource.id, this.original))) {
          return this.update(resource)
        }

        // do nothing for the rest
      }),
      ...this.original.map(resource => {
        // delete resources that no longer exist
        if (!findById(resource.id, modified)) {
          return this.remove(resource)
        }

        // all other updates are handled by the other check
      })
    ])
  }
}
